import { observer } from 'mobx-react-lite'
import { type FC, useEffect } from 'react'
import { Table } from 'shared/ui'
import { type CallHistory } from 'entities/CallHistory/model/CallHistory'
import { getColumns } from 'pages/conversations/pages/calls/ui/CallHistoryTable/ui/getColumns'
import { type CallHistoryStore } from 'pages/conversations/pages/calls/ui/CallHistory'
import styles from './styles.module.scss'

type ICallHistoryTableProps = {
  callHistoryStore: CallHistoryStore
  noPagination?: boolean
}

export const CallHistoryTable: FC<ICallHistoryTableProps> = observer(({ callHistoryStore }) => {
  const { items, total, page, loading, limit, onPaginationModelChange, callHistoryTableStore } =
    callHistoryStore
  const {
    markAsRead,
    visibleColumnsIds,
    hideExpandColumnsIds,
    updateSelectedColumns,
    getSelectedColumns,
    toggleSortOrder,
    changeSortBy,
    sortOrder,
    sortBy,
  } = callHistoryTableStore

  const onRowClick = (callItem: CallHistory) => {
    if (callItem.isUnread) {
      markAsRead(callItem)
    }
    callHistoryStore.onOpenConversation(callItem)
  }

  const onSort = (field: string | number) => {
    toggleSortOrder()
    changeSortBy(field as string)
  }

  useEffect(() => {
    if (!visibleColumnsIds.length) {
      getSelectedColumns()
    }
  }, [])

  return (
    <div className={styles.tableWrap}>
      <Table
        ariaLabel={'CallHistoryTable'}
        columns={getColumns(visibleColumnsIds, callHistoryStore)}
        pinnedColumnNames={['contact']}
        rows={items}
        rowsCount={total}
        isLoading={loading}
        onChangePagination={onPaginationModelChange}
        initPage={page}
        visibleColumnsIds={visibleColumnsIds}
        setVisibleColumnsIds={updateSelectedColumns}
        limit={limit}
        startPaginationSize={10}
        hideExpandColumnsIds={hideExpandColumnsIds}
        sxTable={{ marginRight: 2, width: 'calc(100% - 16px)' }}
        onRowClick={onRowClick}
        onSort={onSort}
        sortOrder={sortOrder}
        sortBy={sortBy}
      />
    </div>
  )
})
